import * as React from "react";
import { GKContent } from "@granular/gds-ux-components";
import { useLocale } from "../next/hooks";
import { getLocaleHelpCenterURL } from "../helpers";
import { getCoreTranslationsFor, getRegionFromUrl } from "../i18n";

const Component: React.FC<{ useGKContent?: boolean }> = ({ useGKContent }) => {
  const locale = useLocale();
  const messages = getCoreTranslationsFor(locale);
  const region = getRegionFromUrl();
  const helpUrl = getLocaleHelpCenterURL(region, locale);

  const content = (
    <>
      <p className="text-center pt-5 mt-5">
        <svg
          width="72"
          height="72"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 28 28"
          fill="#C03031"
        >
          <path d="M0,13 L0,0 L28,0 L28,13 L0,13 Z M0,28 L0,15 L13,15 L13,28 L0,28 Z M22,21 L22,15 L28,15 L28,21 L22,21 Z M15,28 L15,23 L28,23 L28,28 L15,28 Z" />
        </svg>
      </p>
      <h1 className="text-center">{messages.common_fatalErrorTitle}</h1>
      <h4 className="modal-title text-center">{messages.common_fatalError}</h4>
      <p className="text-center pt-4">
        <a className="btn btn-primary mr-1" href="/">
          {messages.common_goHome}
        </a>
        <a
          className="btn btn-outline-primary ml-1"
          href={helpUrl}
          target="blank"
        >
          {messages.common_helpCenter}
        </a>
      </p>
    </>
  );

  if (useGKContent) {
    return <GKContent>{content}</GKContent>;
  }

  return content;
};

export default Component;
